module.exports = __webpack_public_path__ + "static/media/giftImg.e80292d1.svg";